import { useTranslation } from 'react-i18next';
import JsonLd from '@/components/seo/JsonLd';
import { SITE_URL, SITE_NAME } from '@/components/seo/site';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Features from './components/Features';
import ArticleSection from './components/ArticleSection';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  const { t } = useTranslation();

  const faqItems = [1, 2, 3, 4].map((i) => ({
    '@type': 'Question',
    name: t(`faq.q${i}.q`),
    acceptedAnswer: { '@type': 'Answer', text: t(`faq.q${i}.a`) },
  }));

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: SITE_NAME,
          url: SITE_URL,
        }}
      />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: SITE_NAME,
          url: SITE_URL,
          description: t('hero.subtitle'),
          inLanguage: 'en',
        }}
      />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqItems,
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <Features />
        <ArticleSection />
        <Faq />

        <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto text-center rounded-lg border border-background-200 bg-background-100 px-6 py-12 md:py-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              {t('cta.title')}
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              {t('cta.subtitle')}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                {t('cta.button1')}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-6 py-3.5 rounded-md bg-accent-500 text-background-50 font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
              >
                {t('cta.button2')}
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}